import { useState } from "react";
import { GlobalError } from "@components/primitives/input";
import AddressForm from "./AddressForm";
import AddressInfo from "./AddressInfo";
import { AddressComponentProps, initialFormStatusState, FormStatusState } from "./Address.model";

const Address = ({ address, dispatchBilling, states }: AddressComponentProps) => {
  const [formStatusState, setFormStatusState] = useState<FormStatusState>(initialFormStatusState);

  const onToggle = () => {
    setFormStatusState({ ...formStatusState, error: null, editing: !formStatusState.editing });
  };

  return (
    <section>
      {formStatusState.error && (
        <div className="cell small-12 global-error">
          <GlobalError>{formStatusState.error}</GlobalError>
        </div>
      )}
      <h5>Billing Address</h5>
      {formStatusState.editing ? (
        <AddressForm
          address={address}
          dispatchBilling={dispatchBilling}
          formStatus={formStatusState}
          dispatchFormStatus={setFormStatusState}
          states={states}
          onToggle={onToggle}
        />
      ) : (
        <AddressInfo onToggle={onToggle} address={address} />
      )}
    </section>
  );
};

export default Address;
